const localeMap: Record<string, string> = {
  en: 'en-BE',
  fr: 'fr-BE',
  nl: 'nl-BE'
};

export default function dateFormatterFactory(
  lang: string,
  options?: Intl.DateTimeFormatOptions
) {
  return new Intl.DateTimeFormat(localeMap[lang], options);
}
